import { collection, doc, getDocs, query, setDoc } from 'firebase/firestore';
import { db } from './firebase';

export const getPartners = async () => {
    const q = query(collection(db, 'users'))
    const docSnap = await getDocs(q);
    const docs = docSnap.docs.map(doc => {
        return { ...doc.data(), id: doc.id }
    })
    return docs
}

export const updatePartner = async (id, data) => {
    let docRef = doc(db, 'promos', id)
    await setDoc(docRef, { ...data }, { merge: true })
    return 'El usuario se ha actualizado correctamente'
}